module.exports = __webpack_public_path__ + "img/AresTriagem.e6e5e44e.png";